var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.982 8.293a.928.928 0 000 1.414l7.82 7c.437.39 1.144.39 1.58 0l7.821-7a.928.928 0 000-1.414 1.212 1.212 0 00-1.58 0l-7.03 6.293-7.031-6.293a1.212 1.212 0 00-1.58 0z",
    fill: "#222"
  })));
};
export default SvgArrowDown;